import React from 'react';
import { b as CopilotMessagePartWrapper } from '../../CopilotMessagePartWrapper-B-bkNXc6.mjs';
import { CopilotTextPart } from './parts/CopilotTextPart.es.js';
import { CopilotToolPart } from './parts/CopilotToolPart.es.js';

const CopilotMessagePart = ({ message, part, className, style, renderPartContent, isDebug, getToolCallDisplay }) => {
  const override = renderPartContent === null || renderPartContent === void 0 ? void 0 : renderPartContent(message, part);
  if (part.type === "step-start" && !override) {
    return void 0;
  }
  const renderDefault = () => {
    switch (part.type) {
      case "text":
        return React.createElement(CopilotTextPart, { part, message });
      case "tool-invocation":
        return React.createElement(CopilotToolPart, { part, message, isDebug, getToolCallDisplay });
      // In the future we'll add other part types: reasoning, file, etc.
      default:
        return null;
    }
  };
  return React.createElement(CopilotMessagePartWrapper, { role: message.role, className, style }, override !== void 0 ? override : renderDefault());
};
CopilotMessagePart.displayName = "CopilotMessagePart";

export { CopilotMessagePart, CopilotMessagePart as default };
//# sourceMappingURL=CopilotMessagePart.es.js.map
